import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';
import { TokenConnectedItem, TokenItem } from '../core/interfaces/item/TokenItem.interface';
import { DialogService } from '../core/services/dialog.service';
import { LocalStorageService } from '../core/services/localstorage.service';
import { userActions } from '../core/store/userData/userData.actions';
import { selectUser } from '../core/store/userData/userData.selector';
import { IconsEnum } from '../shared/enum/Icons.enum';

@Component({
  selector: 'aoe-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  standalone: false
})
export class MainHeaderComponent implements OnInit {

  public slug!: string | null;
  Icons = IconsEnum;
  private readonly subs = new Subscription();
  user: TokenItem | TokenConnectedItem | null = null;

  constructor(
    private readonly dialogService: DialogService,
    private readonly localStorageService: LocalStorageService,
    private readonly store: Store,
    private readonly router: Router
  ) {
    store.select(selectUser).subscribe(res => this.user = res);
  }

  ngOnInit(): void { }

  openLoginDialog(): void {
    this.dialogService.openLoginModal();
  }

  get userData() {
    if (this.user && ('user' in this.user))
      return this.user['user'];
    return null
  }

  get isConnected(): boolean {
    return !_.isNil(this.userData);
  }

  logout() {
    this.store.dispatch(userActions['[User-API]ResetUser']());
    this.localStorageService.removeElement('t');
    this.router.navigate(['/'])
  }
}
